<template>
  <div v-loading="loading">
    <div class="header">
      <el-button type="primary"
                 @click="$router.push({name: 'SateBudgetRowAdd', query:{state_budget_id: stateBudgetId}})">Qator
        qo'shish
      </el-button>
    </div>
    <el-table :data="tableData" border height="calc(100vh - 250px)" row-key="id"
              default-expand-all>
      <!--      <el-table-column type="index" label="T/r"/>-->
      <el-table-column prop="row_number" label="Raqami">
        <template #default="scope">
          {{ scope.row.parent ? tableData.find(item=>item.id === scope.row.parent).row_number + "." + scope.row.row_number :  scope.row.row_number}}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="Sarlavha" min-width="200"/>
      <el-table-column prop="quarter_1" label="1-chorak" width="120"/>
      <el-table-column prop="quarter_2" label="2-chorak" width="120"/>
      <el-table-column prop="quarter_3" label="3-chorak" width="120"/>
      <el-table-column prop="quarter_4" label="4-chorak" width="120"/>
      <el-table-column prop="annual" label="Yillik" width="120"/>
      <el-table-column align="center" width="280">
        <template #default="scope">
          <el-button size="small" type="primary"
                     @click="$router.push({name: 'SateBudgetRowEdit', params:{id: scope.row.id}})">
            <img src="@/assets/images/icons/edit.svg">
          </el-button>
          <el-button size="small" type="danger"
                     @click="onDelete(scope.row.id)">
            <img src="@/assets/images/icons/delete.svg">
          </el-button>
          <el-button size="small" type="primary"
                     v-if="!scope.row.parent"
                     @click="$router.push({name: 'SateBudgetRowAdd', query:{state_budget_id: stateBudgetId, parent_id: scope.row.id}})">
            Ostki qator qo'shish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";

// Admin panel'ning yagona ishlaydigan interfeys tili — hozircha til
// almashtirgich yo'q, shuning uchun ro'yxatdagi lokalizatsiya qilingan
// `title` ustuni shu tilga mos keladi (state-budget-row-multilang-admin.md).
const HL_HEADER = {hl: "uz_lat"};

export default {
  name: "StateBudgetRows",
  data() {
    return {
      loading: false,
      tableData: [],

      stateBudgetId: null
    }
  },
  methods: {

    onDelete(id) {

      ElMessageBox.confirm(
          'Qatorni o\'chirasizmi?',
          'Diqqat!',
          {
            confirmButtonText: 'Ha',
            cancelButtonText: 'Bekor qilish',
            type: 'warning',
          }
      )
          .then(() => {
            this.loading = true
            this.$http.delete(`/api/v1/state-budget-row/${id}`).then(() => {
              ElMessage({
                type: 'success',
                message: 'Qator muvaffaqiyatli o\'chirildi',
              })
              this.getStateBudgetRows();
            }).catch(() => {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: 'Iltimos, qayta urinib ko\'ring',
              })
            }).finally(() => {
              this.loading = false
            })

          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: 'O\'chirish bekor qilindi',
            })
          })
    },

    getStateBudgetRows() {
      this.loading = true
      this.$http.get(`api/v1/state-budget-row?state_budget_id=${this.stateBudgetId}`, {headers: HL_HEADER}).then(({data}) => {
        this.tableData = data
      }).catch(({response}) => {
        ElNotification.error({
          message: response.data.message || "Ma'lmumot yuklasda xatolik sodir bo'ldi!"
        })
      }).finally(() => {
        this.loading = false
      })
    },

  },
  mounted() {

    if (this.$route.params.stateBudgetId) {
      this.stateBudgetId = this.$route.params.stateBudgetId
      this.getStateBudgetRows();
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 10px;
}
</style>